import styled from 'styled-components'

interface Props {
    $seekBeforeWidth: string
    $bufferedWidth: string
}

export const AudioProgressSlider = styled.input.attrs<Props>({
    type: 'range',
})`
    flex-grow: 1;
    cursor: pointer;
    position: relative;
    padding: 0;
    height: 19px;
    float: left;
    background: none;
    outline: none;
    box-sizing: border-box;
    appearance: none;
    -moz-appearance: none;
    -webkit-appearance: none;
    -ms-progress-appearance: none;

    &::-webkit-slider-runnable-track {
        height: 4px;
        background: ${(p) => p.theme.colors.tertiary.tertiary200};
        border-radius: 4px;
    }

    &::before {
        position: absolute;
        content: '';
        top: 8px;
        left: 0;
        width: ${(p) => p.$seekBeforeWidth};
        height: 4px;
        background-color: ${(p) => p.theme.colors.tertiary.tertiary800};
        border-radius: 4px 0 0 4px;
    }

    &::-webkit-slider-thumb {
        -webkit-appearance: none;
        position: relative;
        height: 15px;
        width: 15px;
        border: 1px solid ${(p) => p.theme.colors.primary.default};
        border-radius: 50%;
        background-color: ${(p) => p.theme.colors.primary.default};
        cursor: pointer;
        margin-top: -6px; /* Center the thumb */
        visibility: hidden; /* Keep the thumb visible */
        transition: transform 0.3s; /* Smooth scaling */
    }

    &:hover::-webkit-slider-thumb,
    &:active::-webkit-slider-thumb {
        transform: scale(1.2);
        visibility: visible;
    }

    &::-moz-range-track {
        height: 4px;
        background: ${(p) =>
            `linear-gradient(to right, rgba(0, 57, 151, 0.5) ${p.$bufferedWidth}, rgba(61, 178, 232, 0.2) ${p.$bufferedWidth})`};
        border-radius: 4px;
    }

    &::-moz-range-thumb {
        height: 15px;
        width: 15px;
        border: 1px solid ${(p) => p.theme.colors.primary.default};
        border-radius: 50%;
        background-color: ${(p) => p.theme.colors.primary.default};
        cursor: pointer;
        margin-top: -6px; /* Center the thumb */
        visibility: hidden; /* Keep the thumb visible */
        transition: transform 0.3s; /* Smooth scaling */
    }

    &:hover::-moz-range-thumb,
    &:active::-moz-range-thumb {
        transform: scale(1.2);
        visibility: visible;
    }

    &::-ms-track {
        width: 100%;
        height: 4px;
        background: transparent;
        border: solid transparent;
        color: transparent;
        border-radius: 4px;
    }

    &::-ms-fill-lower {
        background-color: ${(p) => p.theme.colors.primaryGreen};
    }

    &::-ms-fill-upper {
        background: linear-gradient(
            to right,
            rgba(0, 125, 181, 0.6) ${(p) => p.$bufferedWidth},
            rgba(0, 125, 181, 0.2) ${(p) => p.$bufferedWidth}
        );
    }

    &::-ms-thumb {
        height: 15px;
        width: 15px;
        border: 1px solid ${(p) => p.theme.colors.primary.default};
        border-radius: 50%;
        background-color: ${(p) => p.theme.colors.primary.default};
        cursor: pointer;
    }

    &:active::-ms-thumb {
        transform: scale(1.2);
    }
`
